import ajax from '@/utils/ajax';

const header = '/web';

export const getUserMember = async () => {
  const { data } = await ajax(`${header}/v1/user-member/center/info`);
  return data;
};
export const getMemberLevelInfo = async () => {
  const { data } = await ajax(`${header}/v1/package/member-level`);
  return data;
};
// 根据套餐id集合获取套餐基础信息列表
export const reqCombinationlist = async (endPoint, info) => {
  const { data } = await ajax(`${header}/v1/package/list/0/${endPoint}`, info, 'post');
  return data || [];
};
// 查询套餐详情接口
export const reqCombinationDetail = async (packageId) => {
  const { data } = await ajax(`${header}/v1/package/${packageId}`, '', 'post');
  return data;
};
// 提交订单
export const reqSubOrder = async (info) => {
  const { data, code } = await ajax(`${header}/v1/order/commit`, info, 'POST');
  return { data, code };
};

// 提交订单
export const getWeekly = async () => {
  const { data, code } = await ajax(`${header}/statistics/answer-question-statistics/week`);
  return { data, code };
};

// 基础会员权益
export const getBasicBenefits = async () => {
  const { data } = await ajax(`${header}/v1/dictionary/type/BASIC_MEMBER_BENEFIT`);
  return data;
};
// 高级会员权益
export const getSeniorBenefits = async () => {
  const { data } = await ajax(`${header}/v1/dictionary/type/SENIOR_MEMBER_BENEFI`);
  return data;
};
// 新会员中心权益列表
export const getNewMemberBenefits = async () => {
  const { data } = await ajax(`${header}/v1/dictionary/type/MEMBER_BENEFI_NEW`);
  return data;
};
// 获取展示在底部会员权益的具体内容 包括时政id,专业服务ID,以及优惠券
export const getMemberDetail = async () => {
  const { data } = await ajax(`${header}/v1/dictionary/type/MEMBER_PRODUCT_INFO`);
  return data;
};

// 校验该课程是否购买
export const reqIsBuyProduct = (productId) => ajax(`${header}/v1/user/course/check?productId=${productId}`);

// 获取任务列表
export const getTaskApi = (value) => ajax(`${header}/v1/lms/user-examination/learn-questionnaire?userProductId=${value}`, '', 'GET');
export const getProductInfo = (id) => ajax(`${header}/v1/user/course/userProducts?productIds=${[id]}`);

// 展示班型
export const getClassType = async () => {
  const { data } = await ajax(`${header}/v1/dictionary/type/MINIPROGRAMCLASS`);
  return data;
};
